

/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";
// customerRegister
// CUSTOMERREGISTER
const UPDATEQUESTION= createAsyncThunk(
  "updateQuestion/updateQuestion",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const updateQuestionSlice = createSlice({
  name: "updateQuestionSlice",
  initialState: {
    updateQuestion: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfupdateQuestion: (state) => {
        state.updateQuestion.loading = false
        state.updateQuestion.error = false
        state.updateQuestion.data = []
        state.updateQuestion.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(UPDATEQUESTION.fulfilled, (state, action) => {
      state.updateQuestion = {
        ...state.updateQuestion,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(UPDATEQUESTION.pending, (state, action) => {
      state.updateQuestion = {
        ...state.updateQuestion,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(UPDATEQUESTION.rejected, (state, action) => {
      state.updateQuestion = {
        ...state.updateQuestion,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const updateQuestionAction = {
    UPDATEQUESTION,
};

export { updateQuestionAction };
export default updateQuestionSlice.reducer;
export const {setInitialStateOfupdateQuestion} = updateQuestionSlice.actions
